package com.neurobs.ccabserver.translation.components.translationreplacement.components

import com.neurobs.ccabserver.translation.states.TranslationSubSearchStateGenerator
import com.neurobs.react.semanticui.UiButtonFactory._
import com.neurobs.react.semanticui.UiInputFactory
import org.scalajs.dom
import org.scalajs.dom.console
import slinky.core.{FunctionalComponent, SyntheticEvent, TagElement}
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.core.facade.{React, ReactElement}
import slinky.web.SyntheticMouseEvent
import slinky.web.html._

@react
object TranslationReplacementControl {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val translationSubSearchState = TranslationSubSearchStateGenerator.accessState

    val replacementInputRef = React.createRef[dom.html.Input]

    useEffect(() => {
      if (replacementInputRef.current != null) {
        replacementInputRef.current.value = translationSubSearchState.replacementPhraseState.value
      }
    }, Vector(translationSubSearchState.replacementPhraseState.value))

    def getInputText = if (replacementInputRef.current == null) "" else replacementInputRef.current.value

    def matchingTranslations = translationSubSearchState.matchingTranslationsState.value.getOrElse(Seq())
    def focusedTranslationId = translationSubSearchState.focusedTranslationIdState.value

    def targetAndReplacement = (translationSubSearchState.subPhraseState.value, getInputText)

    def replaceInAll: () => Unit = () => {
      val (target, replacement) = targetAndReplacement
      translationSubSearchState.replaceInAllTranslations(target, replacement)
    }

    def replaceInFocused: () => Unit = () => {
      val (target, replacement) = targetAndReplacement
      translationSubSearchState.replaceInFocusedTranslation(target, replacement)
    }

    def revertFocused: () => Unit = () => translationSubSearchState.revertFocused()
    def revertAll = () => translationSubSearchState.revertAll()

    def ReplaceButton() = {
      if (focusedTranslationId < 0) DisabledButton("Replace")
      else Button("Replace", replaceInFocused)
    }

    def ReplaceAllButton() = {
      if (matchingTranslations.length == 0) DisabledButton("Replace All")
      else Button("Replace All", replaceInAll)
    }

    def RevertButton() = {
      if (focusedTranslationId < 0) DisabledButton("Revert")
      else Button("Revert", revertFocused)
    }

    def RevertAllButton() = {
      if (matchingTranslations.length == 0) DisabledButton("Revert All")
      else Button("Revert All", revertAll)
    }

    def handleMouseOut = (e: SyntheticMouseEvent[input.tagType#RefType]) => {
      translationSubSearchState.replacementPhraseState.setValue(e.target.value)
    }

    props.enclosingElement(
      Seq(
        div(
          className := "ui input"
        )(
          input(
            `type` := "text",
            placeholder := "Replacement",
            ref := replacementInputRef,
            onMouseOut := handleMouseOut,
          )
        ),
        ReplaceButton(),
        RevertButton(),
        ReplaceAllButton(),
        RevertAllButton(),
        TranslationSave(): ReactElement,
        ProgressView(): ReactElement
      )
    )
  }
}
